import is, { isNot } from 'typescript-styled-is'
import styled, { css } from '../../../theme'
import { isFirefox } from '../../DetectBrowser/DetectBrowser'

const ModalWrapper = styled.section<IModalWrapperProps>`
  background-color: white;
  padding: ${({ size }) => (size ? 1.5 * size : 1.5)}em;

  border: none;
  outline: none;
  max-width: 53em;
  
  //Bardzo brzydki fix dla firefoxa :/
  
  ${() =>
    isFirefox()
      ? css`
          &:after {
            content: '';
            display: block;
            height: 0.85em;
          }
        `
      : ''}
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    max-width: 100vw;
    ${isNot('delete')`
    width: 95%;
   `};
    max-height: 95%;
    overflow-y: auto;
  }

  ${is('backgroundColor')`
    background-color: ${({ backgroundColor }: IModalWrapperProps) =>
      backgroundColor};
  `}
`

export default ModalWrapper

export interface IModalWrapperProps {
  backgroundColor?: string
  delete?: boolean
  size?: number
}
